@import './../../../../../styles/global/global-imports';

@import 'scss/screen-xs';

@include breakpoint( minmd ) {
  @import 'scss/screen-md';
}

@include breakpoint( minlg ) {
  @import 'scss/screen-lg';
}
